export class AuditConstants {
    public static readonly phaseOrder = [
        'Cancelled',
        'Collaboration',
        'QA Review',
        'Formatting',
        'Client Signature',
        'In Review',
        'Ready For Approval',
        'Approved',
        'Effective',
        'Archived',
        'Obsolete',
      ];
      public static readonly hardCopyActivityStatusOrder = [
        'Deleted',
        'Scheduled',
        'Pending',
        'Done',
      ];
      public static readonly sessionStatusOrder = [
        'Cancelled',
        'Scheduled',
        'Completed',
      ];
      public static readonly actionItemStatusOrder = [
        'Voided',
        'Scheduled',
        'Pending',
        'Ready For Verification',
        'Deferred',
        'Completed'
      ];
      public static readonly changeControlPhaseOrder = [
        'Collaboration',
        'In Review',
        'Ready For Approval',
        'Implementation',
        'Verification',
        'Complete'
      ];
    

}
